import { DEV_BASE_URL } from '@/constants'

export function joinUrl(baseUrl, url) {
  return new URL(url, baseUrl) + ''
}

export function resolveAssetUrl(url) {
  return location.hostname === 'localhost' ? joinUrl(DEV_BASE_URL, url) : url
}
